import store from '../store'
import StoreConstants from '../StoreConstants'
import api from './api'
import Auth from '@aws-amplify/auth'

export default {

  _applyCredentials(credentials, expiresAt) {
    //used for the new, modular apis
    store.commit(StoreConstants.commits.setCredentials, {
      accessKey: credentials.accessKeyId,
      secretKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
      region: 'us-west-2',
      defaultContentType: 'application/json',
      defaultAcceptType: 'application/json'
    })

    //used for the old monolith api
    api.setCredentials(this, credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken,
      expiresAt
    )
  },

  async appLogin(accountId, deviceUUID, domain, idToken, expiresAt) {
    console.log('appLogin')
    this.idToken = idToken

    store.commit(StoreConstants.commits.setLoggedInEmail, accountId)
    store.commit(StoreConstants.commits.setDeviceUUID, deviceUUID)

    // Use Amplify's federatedSignIn to exchange the native app's token for Identity Pool credentials
    const credentials = await Auth.federatedSignIn(
      domain,
      { token: idToken, expires_at: expiresAt / 1000 },
      { name: accountId }
    )

    this._applyCredentials(credentials, expiresAt)
    console.log('appLogin done')
  },
  async setCurrentSession(session) {

    let expiresAt = session.idToken.payload.exp * 1000
    this.expires_at = expiresAt

    console.log(`expires at ${new Date(this.expires_at).toLocaleString()} (${expiresAt}ms)`)

    this.idToken = session.idToken.jwtToken

    let email = session.idToken.payload.email.trim().toLowerCase()

    store.commit(StoreConstants.commits.setLoggedInEmail, email)

    // Get credentials from Amplify (uses the current session's ID token automatically)
    const rawCredentials = await Auth.currentCredentials()
    const credentials = Auth.essentialCredentials(rawCredentials)

    this._applyCredentials(credentials, this.expires_at)
  },

  getIdToken() {
    return this.idToken
  },

  async logoutAwait(reason, returnTo) {

    store.commit(StoreConstants.commits.setLoggedInEmail, null)

    await Auth.signOut({
      global: false
    })

    if(returnTo) {
      window.location = returnTo
    }
  },
  isLoggedIn() {
    let idToken = this.getIdToken()
    return idToken !== null && idToken !== undefined
  }
}
